
import { toast } from "react-toastify";
import { baseURL } from "../../utils/misc";


export const getAllNextWorkflowStages = async (token, currentWorkflowStageId) => {
  
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/workflowstages/nextworkflowstages/${currentWorkflowStageId}`, requestOptions)
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      console.error("Error fetching Next Workflow Stages for the current Stage.");
      return;
    }
  })
  .then((data) => {
    return data;
  })
  .catch((error) => {
    toast.error("Error fetching Next Workflow Stages for the current Stage.");
    return;
  });
};
